import { AboutApiResponse } from './types';

const API_BASE_URL = 'https://vlsiapi.bssoftcrm.com';

// GET API - Fetch about page content
export const fetchAboutContent = async (): Promise<AboutApiResponse> => {
  try {
    const response = await fetch(`${API_BASE_URL}/About`, {
      method: 'GET',
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data: AboutApiResponse = await response.json();
    return data;
  } catch (error) {
    console.error('Error fetching about content:', error);
    throw error;
  }
};
